import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { jwtDecode } from "jwt-decode";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// PENTING: Import pustaka js-cookie
import Cookies from "js-cookie";

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("Akun Saya");
  const navigate = useNavigate();

  useEffect(() => {
    // PENTING: Cek token dari cookies, bukan localStorage
    const accessToken = Cookies.get("access_token");

    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        const nameFromToken = decodedToken.name || decodedToken.username || decodedToken.full_name;

        if (nameFromToken) {
          setUsername(nameFromToken);
        } else {
          setUsername("Pengguna");
        }
      } catch (error) {
        console.error("Failed to decode JWT:", error);
        setUsername("Pengguna");
      }
    }
  }, [props.success]);

  // Fungsi untuk logout dengan menghapus token dari cookies
  const handleLogout = () => {
    // Hapus token dari cookies
    Cookies.remove("access_token");
    Cookies.remove("refresh_token"); // Hapus refresh token jika digunakan
    
    // Opsional: Hapus juga dari localStorage untuk berjaga-jaga
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    // Arahkan pengguna kembali ke halaman login
    navigate("/login");
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/pengaturan-profil" className="dropdown-item">
            <i className="bx bx-user font-size-16 align-middle me-1 " />
            <span>{props.t("Profil Saya")}</span>
          </Link>
          <DropdownItem onClick={handleLogout} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);